import React, { useContext, useEffect, useState } from 'react'
import Wrapper from '../../../../components/common/Wrapper/Wrapper'
import service from '../../../../api/services'
import organisms from '../../../../components/organisms'
import { Default_Page_Limit } from '../../../../constants/defaultValues'
import { HeaderHeading } from '../../../../Context'
const { MovementDelivered } = organisms
const Index = () => {
    const { setHeader, setSidebar }: any = useContext(HeaderHeading);
    const [deliveredListing, setDeliveredListing] = useState<any>()
    const [initialLoading, setInitialLoading] = useState<boolean>(false);
    const [search, setSearch] = useState('');
    const [pageCount, setPageCount] = useState<number>(1);
    const [limit, setLimit] = useState(Default_Page_Limit);

    const getProcessListing = async () => {
        try {
            const response = await service.movement.deliveredListing({ search: search, page: pageCount, limit: limit, });
            if (response.status === 200) {
                setDeliveredListing(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        setHeader("Movement - Delivered")
        setSidebar(false)
        getProcessListing()
    }, [ pageCount])

    useEffect(() => {
        setPageCount(1)
        if (pageCount == 1 && initialLoading) {
            getProcessListing()
        }
        setInitialLoading(true)
    }, [search,limit])

    return (
        <Wrapper>
            <MovementDelivered
                limit={limit}
                currentPage={pageCount}
                deliveredListing={deliveredListing}
                setSearch={setSearch}
                setLimitPerPage={setLimit}
                setCurrentPage={setPageCount}
            />
        </Wrapper>
    )
}

export default Index